import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import ConnectionsComponent from '../Components/DataService/ConnectionsComponent';

function DataServiceConnectionsPage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <ConnectionsComponent />
    </div>
  );
}

export default DataServiceConnectionsPage;


